import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmpty = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 144,
	viewBox: "0 0 144 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 144,
			height: 144,
			rx: 72,
			fill: "url(#paint0_linear_7989_26951)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_7989_26951)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 30.0664,
					y: 64.4688,
					width: 84.2667,
					height: 40.5333,
					rx: 10.6667,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 50.3335,
					cy: 84.7339,
					r: 13.8667,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 68.4668,
					y: 74.0703,
					width: 39.4667,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 68.4668,
					y: 86.8711,
					width: 40.5333,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 30.3331,
					y: 64.7354,
					width: 83.7333,
					height: 40,
					rx: 10.4,
					stroke: "#E8E8EC",
					strokeWidth: .533333
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_7989_26951)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 19.4004,
					y: 54.8672,
					width: 105.6,
					height: 40.5333,
					rx: 10.6667,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 39.6674,
					cy: 75.1323,
					r: 13.8667,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 57.8008,
					y: 64.4688,
					width: 60.8,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 57.8008,
					y: 77.2695,
					width: 40.5333,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 19.6671,
					y: 55.1339,
					width: 105.067,
					height: 40,
					rx: 10.4,
					stroke: "#E8E8EC",
					strokeWidth: .533333
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_7989_26951)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 13,
					y: 41,
					width: 118.4,
					height: 40.5333,
					rx: 10.6667,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 33.2671,
					cy: 61.2651,
					r: 13.8667,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 51.4004,
					y: 50.6016,
					width: 73.6,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 51.4004,
					y: 63.4023,
					width: 40.5333,
					height: 8.53333,
					rx: 2.13333,
					fill: "#F6F6F7"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 13.2667,
					y: 41.2667,
					width: 117.867,
					height: 40,
					rx: 10.4,
					stroke: "#E8E8EC",
					strokeWidth: .533333
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_7989_26951",
				x: 25.7997,
				y: 63.4021,
				width: 92.7999,
				height: 49.0685,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.06667,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.66667 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.541176 0 0 0 0 0.580392 0 0 0 0 0.65098 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_7989_26951",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_7989_26951",
				x: 15.1337,
				y: 53.8005,
				width: 114.133,
				height: 49.0685,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.06667,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.66667 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.541176 0 0 0 0 0.580392 0 0 0 0 0.65098 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_7989_26951",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_7989_26951",
				x: 8.73333,
				y: 39.9333,
				width: 126.934,
				height: 49.0685,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1.06667,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.66667 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.541176 0 0 0 0 0.580392 0 0 0 0 0.65098 0 0 0 0.13 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_7989_26951"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_7989_26951",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7989_26951",
				x1: 72,
				y1: 0,
				x2: 72,
				y2: 144,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .332773,
					stopColor: "#F6F6F7"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F6F6F7",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
